export default __webpack_public_path__ + "static/media/wallet-thin-svgrepo-com.8eac1b49.svg";